import { render } from "./productions.vue?vue&type=template&id=08de0df6&scoped=true"
import script from "./productions.vue?vue&type=script&lang=js"
export * from "./productions.vue?vue&type=script&lang=js"

import "./productions.vue?vue&type=style&index=0&id=08de0df6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08de0df6"]])

export default __exports__